/* eslint-disable */
class drawImage {
  constructor (obj) {
    this.init(obj)
    this.getImageData(obj.img).then(res => {
      this.imageData = res
      this.getSpot()
      this.getDrawSpot()
      this.draw()
    })
  }

  init (obj) {
    const nodeStr = obj.node || document.body
    this.node = typeof nodeStr === 'object' ? nodeStr : document.querySelector(nodeStr)
    const options = this.node.getBoundingClientRect()
    this.canvas = this.createCanvas(options)
    this.canvas.setAttribute('class', 'welcome-cav')
    this.ctx = this.canvas.getContext('2d')
    this.node.appendChild(this.canvas)
    // 存储要绘制的点
    this.drawSpotArr = []
    // 存储粒子对象
    this.spot = []
    // 颜色
    this.color = obj.color
  }

  getImageData (url) {
    const img = new Image()
    img.src = url + '?v=' + Math.random()
    return new Promise(res => {
      img.onload = () => {
        const canvas = this.createCanvas({ width: img.width, height: img.height })
        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0)
        const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height)
        res(imgData)
      }
    })
  }

  // 创建canvas
  createCanvas (options) {
    const canvas = document.createElement('canvas')
    canvas.width = options.width
    canvas.height = options.height
    return canvas
  }

  // 获取点
  getSpot () {
    const { width, height, data } = this.imageData
    const canvas = this.canvas
    const startX = (canvas.width - width) / 2
    const startY = (canvas.height - height) / 2
    const spot = []
    for (let i = 0; i < height; i++) {
      for (let j = 0; j < width; j++) {
        const opacity = (i * width * 4) + (j * 4) + 3
        if (data[opacity] > 0) {
          spot.push({
            x: j + startX,
            y: i + startY,
            color: `rgba(${data[opacity - 3]}, ${data[opacity - 2]}, ${data[opacity - 1]},  ${data[opacity] / 255})`,
            colors: [data[opacity - 3], data[opacity - 2], data[opacity - 1], data[opacity] / 255],
            initSpot: {
              x: Math.random() * canvas.width,
              y: Math.random() * canvas.height,
              position: false
            }
          })
        }
      }
    }
    this.spot = spot
  }

  // 得到动画点
  getSpotAni () {

  }

  // 获取点
  getDrawSpot () {
    let cx = -4; let cy = -4; let state = 0
    this.spot.forEach(item => {
      const { x, y } = item
      if (x < cx) {
        cx = -4
        cy = state
      }
      if (y <= (cy + 3)) return false
      if (x > (cx + 3)) {
        this.drawSpotArr.push(item)
        cx = x
        state = y
      }
    })
  }

  draw (step) {
    const { ctx, canvas } = this
    const options = this.node.getBoundingClientRect()
    canvas.width = options.width
    canvas.height = options.height
    let count = 0
    let time = 5
    step = step || 40
    const changeSpot = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      this.drawSpotArr.forEach(item => {
        const initSpot = item.initSpot
        if (initSpot.x > item.x) {
          if (Math.abs(initSpot.x - item.x) > step) {
            initSpot.x -= step
          } else {
            initSpot.x = item.x + (Math.random() * 2 - 1)
          }
        } else {
          if (Math.abs(initSpot.x - item.x) > step) {
            initSpot.x += step
          } else {
            initSpot.x = item.x + (Math.random() * 2 - 1)
          }
        }
        if (initSpot.y > item.y) {
          if (Math.abs(initSpot.y - item.y) > step) {
            initSpot.y -= step
          } else {
            initSpot.y = item.y + (Math.random() * 2 - 1)
          }
        } else {
          if (Math.abs(initSpot.y - item.y) > step) {
            initSpot.y += step
          } else {
            initSpot.y = item.y + (Math.random() * 2 - 1)
          }
        }
        if ((Math.abs(initSpot.x - item.x) < 3) && Math.abs(initSpot.y - item.y) < 3 && !initSpot.position) {
          initSpot.position = true
          count++
        }
        const { x, y } = initSpot
        ctx.beginPath()
        ctx.strokeStyle = this.handlerColor(item.colors, this.color)
        ctx.fillStyle = this.handlerColor(item.colors, this.color)
        ctx.arc(x + 2, y + 2, 2, 0, 2 * Math.PI)
        // ctx.stroke()
        ctx.fill()
        ctx.closePath()
        if (count >= this.drawSpotArr.length && time < 200) {
          clearInterval(play)
          time = 1000
          // this.play = setInterval(changeSpot, 160)
        }
      })
    }
    const play = setInterval(changeSpot, time)
  }

  handlerColor (arr, color) {
    if (arr[0] >= 255 && arr[1] >= 255 && arr[2] >= 255 && arr[3] >= 1) {
      return `rgba(${arr[0]},${arr[1]},${arr[2]},1)`
    }
    return color
  }
}

export default drawImage
